// extracted by css-extract-rspack-plugin
export default {"truncated":"TextCopy_truncated__0_Nv1","full_width":"TextCopy_full_width__roG6w"};